import lockAsync from '@xfe-team/utils/src/lock-async';
import protect from '@src/error/protect';

/**
 * 守护 events, 确保入口函数异常能够被正确捕获
 * @param {object} clazz - 装饰器属性
 * @param {string} methodName - 装饰器属性
 * @param {object} descriptor - 装饰器属性
 * @return {{set(), get(): any}}
 */
const entry = (instance, methodName, descriptor = Object.getOwnPropertyDescriptor(instance, methodName)) => {
  let value = instance[methodName] || (descriptor.initializer && descriptor.initializer.call(this));
  Object.keys(value).forEach(key => {
    const descriptor = Object.getOwnPropertyDescriptor(value, key);
    const nativeFunc = descriptor.value;
    const locker = lockAsync();
    value[key] = (...args) => protect()(() => locker(() => nativeFunc.call(instance, ...args)));
  });
  return {
    get() {
      return value;
    }
  };
};

export default entry;



// WEBPACK FOOTER //
// ./src/components/vm-component/entry/index.js